import React, { useState, useEffect } from 'react';
import { Card, Form, Row, Col, Button } from 'reactstrap';
import { useParams } from 'react-router-dom'; 
import Flatpickr from "react-flatpickr"; 
import { addOEM,updateOEM, getOEMById ,baseURL} from '../../utils/oem';
import { addCompanyLogo } from '../../utils/imageapi'; // 新增图片上传API
import { Link, useNavigate,useLocation } from "react-router-dom";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import { ToastContainer, toast } from 'react-toastify';

const CompanySetting = () => {
    const location = useLocation(); // Get current location
    const searchParams = new URLSearchParams(location.search);
    const companyId = searchParams.get("companyId");  
  const navigate = useNavigate();
  
  const user = JSON.parse(sessionStorage.getItem("user")); 
  console.log(user);

  const [formData, setFormData] = useState({
    oem_brandname: '',
    oem_companyname: '',
    company_public_id: '',
    tax_id: '',
    currency: 'USD',
    contact_name: '',
    contact_email: '',
    contact_phone: '',
    street: '',
    province: '',
    city: '',
    country: 'United States',
    zipcode: '',
    contract_start: new Date(),
    contract_end: new Date()
  });
  const [logoUrl, setLogoUrl] = useState("");
  const [storefrontUrl, setStorefrontUrl] = useState("");
  const [logoFile, setLogoFile] = useState(null);
  const [storefrontFile, setStorefrontFile] = useState(null);
  const [isUploadingLogo, setIsUploadingLogo] = useState(false);
  const [isUploadingStorefront, setIsUploadingStorefront] = useState(false);
  const errornotify = (error) => toast(error, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-danger text-white' });
  const successnotify = (success) => toast(success, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-success text-white' });
  useEffect(() => {
    
    if(companyId){ 
      fetchCompanyData();
    }
  }, []);
  const [errors, setErrors] = useState({});
  const fetchCompanyData = async () => {
    try {
      const response = await getOEMById(companyId);
      if(response.status==200){  
          const data = response.data.data;
          if(data.images.length>0){
            data.images.forEach((image)=>{
              if(image.is_logo){
                setLogoUrl(`${baseURL}/file/oem/image/${image.image_url}`); // 主logo
              }
              if(image.storefront_image){
                setStorefrontUrl(`${baseURL}/file/oem/image/${image.image_url}`); // 店面
              }
            })   
          }
          // 转换日期格式
          data.contract_start = new Date(data.contract_start);
          data.contract_end = new Date(data.contract_end);
          setFormData(data);
          successnotify(response.message)
        }else {
          errornotify(response.message)  
        } 
    } catch (error) {
      console.error('Error fetching company data:', error);
    }
  };
  // 在handleChange后新增验证方法
  const validateField = (name, value) => {
    const validationRules = {
        oem_brandname: 'Brand Name is required',
        oem_companyname: 'Company Name is required',
        company_public_id: 'Company Public ID is required',
        tax_id: 'Tax ID is required'
    };

    setErrors(prev => ({
        ...prev,
        [name]: validationRules[name] && !value.trim() 
                ? validationRules[name] 
                : ''
    }));
};
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if(companyId){  
        const response = await updateOEM(companyId,formData);
        if(response.status === 200){  
          successnotify(response.data.message);
          
          // 并行执行文件上传
          await Promise.all([
            handleLogoUpload(response.data.data.id),
            handleStorefrontUpload(response.data.data.id)
          ]);
          
          navigate(`/company?companyId=${response.data.data.id}`);
        }else{
          errornotify(response.response.data.message);
        }
      } else {
        const response = await addOEM(formData);
        if(response.status === 200){
          successnotify(response.data.message);
          
          // 并行执行文件上传
          await Promise.all([
            handleLogoUpload(response.data.data.id),
            handleStorefrontUpload(response.data.data.id) 
          ]); 
          navigate(`/company?companyId=${response.data.data.id}`);
        }else{ 
          errornotify(response.response.data.message);
        }
      }
    } catch (error) {
      console.error('Error:', error);
      errornotify(error.message);
    }
  };

  const handleChange = (e) => {
    debugger
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleLogoChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setLogoFile(selectedFile);
      setLogoUrl(URL.createObjectURL(selectedFile));  // 生成预览URL
    }
  };
  const handleStorefrontChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setStorefrontFile(selectedFile);
      setStorefrontUrl(URL.createObjectURL(selectedFile));  // 生成预览URL
    }
  };
  // 新增logo上传处理
  const handleLogoUpload = async (id) => { 
    if (!logoFile) {
        errornotify("Please select an image to upload.")
        return;
    }
    
    setIsUploadingLogo(true);
    const formData = new FormData();
    formData.append("image", logoFile);
    formData.append("is_logo", true);
    formData.append("oem_id", id);
    
    try {
      const response = await addCompanyLogo(formData);
      if (response.filename) {
        successnotify(response.message || "Upload main image successful.") 
        // setMainImageUrl(`${baseURL}/file/evnet/image/${response.filename}`); // Store uploaded image URL
       }else{
         errornotify(response.message || "Upload main image failed.")
       }
    } catch (error) {
      console.error("Logo upload failed:", error);
    } finally {
      setIsUploadingLogo(false);
    }
  };

  // 新增店面照片上传处理
  const handleStorefrontUpload = async (id) => {  
    if (!storefrontFile) {
        errornotify("Please select an image to upload.")
        return;
      }
    
    setIsUploadingStorefront(true);
    const formData = new FormData();
    formData.append("image", storefrontFile);
    formData.append("is_main_image", true);
    formData.append("oem_id", id);
    
    try {
      const response = await addCompanyLogo(formData);
      if (response.filename) {
        setStorefrontUrl(`${baseURL}/file/oem/image/${response.filename}`);
        setFormData(prev => ({...prev, storefront_photo: response.filename}));
      }
    } catch (error) {
      console.error("Storefront upload failed:", error);
    } finally {
      setIsUploadingStorefront(false);
    }
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <BreadCrumb title={companyId?'Company Edit':'Company Add'} pageTitle="Ecommerce" />
        <ToastContainer />
        <Card className="p-4">
            
        <Form onSubmit={handleSubmit}>
            <div className="d-flex mb-4" style={{borderBottom:"solid 1px #ddd"}}>
                <div className="d-flex justify-content-between w-100">
                    <h4 className="card-title mb-4">{formData.oem_companyname||'Company'}</h4>
                    <div className="flex-shrink-0 mb-4">
                        <Button type="submit" color="primary" className="mt-3">
                            Save Changes
                        </Button> 
                        </div>
                </div>
            </div> 
            <Row className="mb-4">
                <Col md={6}>
                <div className="mb-3">
                    <label>Company Logo</label>
                    <div className="avatar-upload">
                    <input 
                        type="file" 
                        id="logo-upload" 
                        accept="image/*"
                        onChange={handleLogoChange}
                        disabled={isUploadingLogo}
                        hidden
                    />
                    <label htmlFor="logo-upload" className="d-block cursor-pointer">
                        {logoUrl ? (
                        <img src={logoUrl} alt="Logo" className="rounded" width="120" />
                        ) : (
                        <div className="avatar-placeholder bg-light d-flex align-items-center justify-content-center rounded-circle" 
                            style={{width: '120px', height: '120px'}}>
                            {isUploadingLogo ? (
                            <div className="spinner-border text-primary"></div>
                            ) : (
                            <i className="ri-camera-line fs-2"></i>
                            )}
                        </div>
                        )}
                    </label>
                    </div>
                </div>
                </Col>
                
                <Col md={6}>
                <div className="mb-3">
                    <label>Storefront Photo</label>
                    <div className="storefront-upload">
                    <input 
                        type="file" 
                        id="storefront-upload" 
                        accept="image/*"
                        onChange={handleStorefrontChange}
                        disabled={isUploadingStorefront}
                        hidden
                    />
                    <label htmlFor="storefront-upload" className="d-block cursor-pointer">
                        {storefrontUrl ? (
                        <img src={storefrontUrl} alt="Storefront" className="img-fluid rounded"   style={{
                          
                          height: '200px',  // 固定高度
                          objectFit: 'cover' // 保持图片比例
                      }}  />
                        ) : (
                          <div className="bg-light p-4 rounded d-flex align-items-center justify-content-center" 
                          style={{ 
                              height: '200px',  // 固定高度
                              overflow: 'hidden' // 添加溢出隐藏
                          }}>
                          {isUploadingStorefront ? (
                              <div className="spinner-border text-primary"></div>
                          ) : (
                              <div className="text-center">
                                  <i className="ri-image-line fs-2 mb-2"></i>
                                  <p className="mb-0">Upload Photo</p>
                              </div>
                          )}
                      </div>
                        )}
                    </label>
                    </div>
                </div>
                </Col>
            </Row>
            {/* Company Information */}
            <Row className="mb-3">
                <Col md={6}>
                <div className="mb-3">
                    <label>OEM Company Name</label> 
                    <input
                      type="text"
                      className={`form-control ${errors.oem_companyname ? 'is-invalid' : ''}`}
                      name="oem_companyname"
                      value={formData.oem_companyname}
                      onChange={(e) => {
                          handleChange(e);
                          validateField('oem_companyname', e.target.value);
                      }}
                      onBlur={(e) => validateField('oem_companyname', e.target.value)}
                      required
                  />
                  {errors.oem_companyname && (
                      <div className="invalid-feedback">
                          {errors.oem_companyname}
                      </div>
                  )}
                </div>
                <div className="mb-3">
                    <label>Brand Name</label> 
                    <input
                      type="text"
                      className={`form-control ${errors.oem_brandname ? 'is-invalid' : ''}`}
                      name="oem_brandname"
                      value={formData.oem_brandname}
                      onChange={(e) => {
                          handleChange(e);
                          validateField('oem_brandname', e.target.value);
                      }}
                      onBlur={(e) => validateField('oem_brandname', e.target.value)}
                      required
                  />
                  {errors.oem_brandname && (
                      <div className="invalid-feedback">
                          {errors.oem_brandname}
                      </div>
                  )}
                </div>
                <div className="mb-3">
                    <label>Company Public ID</label> 
                    <input
                      type="text"
                      className={`form-control ${errors.company_public_id ? 'is-invalid' : ''}`}
                      name="company_public_id"
                      value={formData.company_public_id}
                      onChange={(e) => {
                          handleChange(e);
                          validateField('company_public_id', e.target.value);
                      }}
                      onBlur={(e) => validateField('company_public_id', e.target.value)}
                      required
                  />
                  {errors.company_public_id && (
                      <div className="invalid-feedback">
                          {errors.company_public_id}
                      </div>
                  )}
                </div>
                </Col>
                <Col md={6}>
                <div className="mb-3">
                    <label>Tax ID</label> 
                    <input
                      type="text"
                      className={`form-control ${errors.tax_id ? 'is-invalid' : ''}`}
                      name="tax_id"
                      value={formData.tax_id}
                      onChange={(e) => {
                          handleChange(e);
                          validateField('tax_id', e.target.value);
                      }}
                      onBlur={(e) => validateField('tax_id', e.target.value)}
                      required
                  />
                  {errors.tax_id && (
                      <div className="invalid-feedback">
                          {errors.tax_id}
                      </div>
                  )}
                </div>
                <div className="mb-3">
                    <label>Currency</label>
                    <select
                    className="form-select"
                    name="currency"
                    value={formData.currency}
                    onChange={handleChange}
                    >
                    <option value="USD">USD</option>
                    <option value="EUR">EUR</option>
                    <option value="CNY">CNY</option>
                    </select>
                </div>
                <div className="mb-3">
                    <label>ZIP Code</label>
                    <input
                    type="text"
                    className="form-control"
                    name="zipcode"
                    value={formData.zipcode}
                    onChange={handleChange}
                    />
                </div>
                </Col>
            </Row>

            {/* Contact Information */}
            <h5 className="mb-3">Contact Information</h5>
            <Row className="mb-4">
                <Col md={4}>
                <div className="mb-3">
                    <label>Contact Name</label>
                    <input
                    type="text"
                    className="form-control"
                    name="contact_name"
                    value={formData.contact_name}
                    onChange={handleChange}
                    />
                </div>
                </Col>
                <Col md={4}>
                <div className="mb-3">
                    <label>Email</label>
                    <input
                    type="email"
                    className="form-control"
                    name="contact_email"
                    value={formData.contact_email}
                    onChange={handleChange} 
                    />
                </div>
                </Col>
                <Col md={4}>
                <div className="mb-3">
                    <label>Phone</label>
                    <input
                    type="tel"
                    className="form-control"
                    name="contact_phone"
                    value={formData.contact_phone}
                    onChange={handleChange}
                    />
                </div>
                </Col>
            </Row>

            {/* Address Information */}
            <h5 className="mb-3">Address</h5>
            <Row className="mb-4">
                <Col md={6}>
                <div className="mb-3">
                    <label>Street</label>
                    <input
                    type="text"
                    className="form-control"
                    name="street"
                    value={formData.street}
                    onChange={handleChange}
                    />
                </div>
                <div className="mb-3">
                    <label>City</label>
                    <input
                    type="text"
                    className="form-control"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    />
                </div>
                </Col>
                <Col md={6}>
                <div className="mb-3">
                    <label>Province/State</label>
                    <input
                    type="text"
                    className="form-control"
                    name="province"
                    value={formData.province}
                    onChange={handleChange}
                    />
                </div>
                <div className="mb-3">
                    <label>Country</label>
                    <input
                    type="text"
                    className="form-control"
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                    />
                </div>
                </Col>
            </Row>

            {/* Contract Dates */}
            <h5 className="mb-3">Contract Period</h5>
            <Row className="mb-4">
                <Col md={6}>
                <div className="mb-3">
                    <label>Start Date</label>

                <Flatpickr
                    value={formData.contract_start}
                    onChange={(date) => setFormData({...formData, contract_start: date[0]})}
                    className="form-control"
                    />
                </div>
                </Col>
                <Col md={6}>
                <div className="mb-3">
                    <label>End Date</label>
                    <Flatpickr
                    value={formData.contract_end}
                    onChange={(date) => setFormData({...formData, contract_end: date[0]})}
                    className="form-control"
                    />
                </div>
                </Col>
            </Row> 
            </Form>
        </Card>
        </div>
    </React.Fragment>
  );
};

export default CompanySetting;